import { Outlet, useMatch } from 'react-router-dom';
import type { ReactNode } from 'react';

interface ModuleColumnsProps {
  /** Die Listen-Spalte des Moduls (besitzt ihren eigenen Scroll-Container). */
  list: ReactNode;
  /**
   * Pfadmuster, ab denen die Listen-Spalte schmaler wird und die Detail-Spalte
   * erscheint — verschachtelte Details als explizite Muster angeben
   * (z. B. ['/bauvorhaben/:id', '/bauvorhaben/:id/edit']), damit Lesen und
   * Bearbeiten beide zählen.
   */
  detailPatterns: string[];
}

/**
 * Modul-Spaltengruppe: hält die Listen-Spalte gemountet (State überlebt die
 * Detail-Navigation) und blendet die Detail-Spalte (Outlet) daneben ein.
 * Mobil immer nur eine Spalte sichtbar: Liste ↔ Detail.
 */
export function ModuleColumns({ list, detailPatterns }: ModuleColumnsProps) {
  const hasDetail = detailPatterns.some((pattern) => useMatch(pattern) !== null);

  return (
    <>
      <div
        className={
          hasDetail
            ? 'hidden min-h-0 shrink-0 flex-col md:flex md:w-[300px] xl:w-[380px] md:border-r md:border-gray-200'
            : 'flex min-h-0 min-w-0 flex-1 flex-col'
        }
      >
        {list}
      </div>
      <div
        className={
          hasDetail
            ? 'flex min-w-0 flex-1 flex-col overflow-y-auto'
            : 'hidden'
        }
      >
        <Outlet />
      </div>
    </>
  );
}